<template>
  <Brands
    :brands="brands"
    :title="$t('enterprise.index.trustedFeatured.featured')"
    :height="45"
    :margin="margin"
  />
</template>

<script>
import Brands from '@/components/Common/Brands';

export default {
  name: 'FeaturedIn',
  components: {
    Brands
  },
  props: {
    margin: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => {
    return {
      brands: [
        { src: 'https://cdn.vexels.com/img/featured/logo-1.png', alt: 'Smashing' },
        { src: 'https://cdn.vexels.com/img/featured/logo-2.png', alt: 'In Vision' },
        { src: 'https://cdn.vexels.com/img/featured/logo-3.png', alt: 'Creative Blob' },
        { src: 'https://cdn.vexels.com/img/featured/logo-4.png', alt: 'Just Creative' },
        { src: 'https://cdn.vexels.com/img/featured/logo-5.png', alt: 'W' }
      ]
    };
  }
};
</script>
